module.exports = __webpack_public_path__ + "static/media/syme-logo.cdd77600.png";